var $65f73c6fde514402$exports = {};
$65f73c6fde514402$exports = {
    "backButton": (args)=>`Palaa kohtaan ${args.prevMenuButton}`,
    "moreActions": `Lis\xe4\xe4 toimintoja`,
    "unavailable": `Ei saatavilla, laajenna saadaksesi lis\xe4tietoja`
};


export {$65f73c6fde514402$exports as default};
//# sourceMappingURL=fi-FI.module.js.map
